// extracted by mini-css-extract-plugin
module.exports = {"root":"Wrapper-module__root___WsLq3"};